// `row`/`column` restart at each floor on double-decker buses, so each seat
// carries its own floorNumber/floorLabel (from layout.floors) and is left
// unstacked — the UI shows one floor at a time via a floor switcher.
export function mapSeatCells(layout) {
	const floorLabelByNumber = {}

	;(layout.floors || []).forEach((floor) => {
		floorLabelByNumber[floor.floorNumber] = floor.label
	})

	return layout.cells
		.filter(({ seatNumber, isAvailable }) => seatNumber !== '' && isAvailable)
		.map((cell) => ({
			...cell,
			x: cell.row,
			y: cell.column,
			number: cell.seatNumber,
			available: cell.isAvailable,
			floorLabel: floorLabelByNumber[cell.floorNumber],
			// Spec 055: cada andar pode ter classe tarifária e preço próprios. `seatId` ("andar:número")
			// identifica a poltrona (o número se repete entre andares); `seatPrice` é o preço da classe
			// dela (usado no aviso de saldo de pontos — o preço não é exibido no mapa).
			seatId: cell.seatId || `${cell.floorNumber || 1}:${cell.seatNumber}`,
			seatPrice: cell.price,
		}))
}

